import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import fr from 'date-fns/locale/fr';
import en from 'date-fns/locale/en-US';

switch (document.querySelector('meta[name="locale"]')?.content) {
    case 'en':
        window.dateLocale = en;
        break;
    case 'fr':
        window.dateLocale = fr;
        break;
    default:
        window.dateLocale = pt;
        break;
}

document.querySelectorAll('[data-iso-date]').forEach((el) => {
    const isoDate = el.getAttribute('data-iso-date');
    const formatString = el.getAttribute('data-format') || 'dd MMMM yyyy - HH:mm';
    el.textContent = format(new Date(isoDate), formatString, { locale: window.dateLocale });
});
